/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

export const MICROSOFT_DOMAIN_REGEX = new RegExp("[a-z0-9_@./#&+-]+@microsoft.com");
